/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionOralDietViewFragmentAliases {
  CONTEXTUAL_ORAL_DIET_BALANCE = 'contextual-oral-diet-balance',
  FIELD_DIET = 'field-diet',
  FIELD_DIET_INFORMATION = 'field-diet-information',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HOURS = 'field-hours',
  FIELD_INTERVAL = 'field-interval',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_NUTRITIONAL_CALORIC_PROFILE = 'field-nutritional-caloric-profile',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_START_DATE = 'field-start-date',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_ORAL_DIET = 'layout-oral-diet',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_DIET = 'text-diet',
  TEXT_DIET_INFORMATION = 'text-diet-information',
  TEXT_DURATION = 'text-duration',
  TEXT_HOURS = 'text-hours',
  TEXT_INTERVAL = 'text-interval',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_NUTRITIONAL_CALORIC_PROFILE = 'text-nutritional-caloric-profile',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
}
export { NutritionOralDietViewFragmentAliases };
